/* el-stories.js — sections/el-stories.liquid
   Topic tabs (arrow keys move between them), the progress line and mouse drag for the review row. */
(function () {
  'use strict';

  if (window.elStoriesReady) return;
  window.elStoriesReady = true;

  function select(section, tab) {
    var id = tab.getAttribute('data-el-stories-tab');
    section.querySelectorAll('[data-el-stories-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    /* Mobile: bring the chosen tab fully into the swipeable row */
    var row = tab.parentNode;
    if (row && row.scrollWidth > row.clientWidth) {
      var left = tab.offsetLeft - parseFloat(getComputedStyle(row).paddingLeft || 0);
      row.scrollTo({ left: Math.max(0, Math.min(left, row.scrollWidth - row.clientWidth)), behavior: 'smooth' });
    }
    section.querySelectorAll('[data-el-stories-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-el-stories-panel') !== id;
      var track = p.querySelector('[data-el-stories-track]');
      if (!p.hidden && track) { track.scrollLeft = 0; progress(track); }
    });
  }

  /* Thumb is 1 / cards wide and slides with the scroll position */
  function progress(track) {
    var panel = track.closest('[data-el-stories-panel]');
    if (!panel) return;
    var count = track.children.length || 1;
    var max = track.scrollWidth - track.clientWidth;
    panel.style.setProperty('--el-st-count', count);
    panel.style.setProperty('--el-st-progress', max > 0 ? track.scrollLeft / max : 0);
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-el-stories-tab]');
    var section = tab && tab.closest('[data-el-stories]');
    if (section) select(section, tab);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('[data-el-stories-tab]');
    if (!tab || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[data-el-stories-tab]'));
    var next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    next.focus();
    select(tab.closest('[data-el-stories]'), next);
  });

  document.addEventListener('scroll', function (event) {
    var track = event.target.closest && event.target.closest('[data-el-stories-track]');
    if (track) progress(track);
  }, true);

  /* Mouse drag for review rows that scroll sideways (touch and trackpads already swipe).
     Snapping is paused while dragging, then the row settles on the nearest card. */
  var drag = null;
  document.addEventListener('dragstart', function (event) {
    if (event.target.closest && event.target.closest('[data-el-stories-track]')) event.preventDefault();
  });
  document.addEventListener('pointerdown', function (event) {
    var track = event.pointerType === 'mouse' && event.button === 0 && event.target.closest && event.target.closest('[data-el-stories-track]');
    if (!track || track.scrollWidth <= track.clientWidth) return;
    drag = { track: track, x: event.clientX, left: track.scrollLeft, moved: false, id: event.pointerId };
  });
  document.addEventListener('pointermove', function (event) {
    if (!drag) return;
    var dx = event.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) < 4) return;
    if (!drag.moved) {
      drag.moved = true;
      drag.track.style.scrollSnapType = 'none';
      drag.track.classList.add('is-dragging');
    }
    drag.track.scrollLeft = drag.left - dx;
  });
  function endDrag() {
    if (!drag) return;
    var d = drag; drag = null;
    if (!d.moved) return;
    var track = d.track;
    track.classList.remove('is-dragging');
    var origin = track.getBoundingClientRect().left;
    var best = null, bestD = Infinity;
    Array.prototype.forEach.call(track.children, function (c) {
      var dist = Math.abs(c.getBoundingClientRect().left - origin);
      if (dist < bestD) { bestD = dist; best = c; }
    });
    var target = best ? track.scrollLeft + best.getBoundingClientRect().left - origin : track.scrollLeft;
    track.scrollTo({ left: target, behavior: 'smooth' });
    setTimeout(function () { track.style.scrollSnapType = ''; }, 400);
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  function init() { document.querySelectorAll('[data-el-stories-track]').forEach(progress); }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor: show the tab of the review being edited */
  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.closest && event.target.closest('[data-el-stories-panel]');
    var section = panel && panel.closest('[data-el-stories]');
    if (!section) return;
    var tab = section.querySelector('[data-el-stories-tab="' + panel.getAttribute('data-el-stories-panel') + '"]');
    if (tab) select(section, tab);
  });
})();
